import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Assets
import { fonts } from '../../../../styles/variables';
import { updateField } from '../../../../store/ContactForm/actions';

const AreaSection = styled.div`
  padding-top: 10px;
  min-height: 50px;
`;

const AreaProper = styled.textarea`
  border-radius: 0;
  outline: none;
  background: transparent;
  background-size: 100% 36px;
  box-shadow: none;
  line-height: 38px;
  border: 0;
  font-size: 18px;
  letter-spacing: 1px;
  max-width: 100%;
  min-width: 100%;
  max-height: 250px;
  min-height: 100px;
  ${({ color, textColor, textFont }) => `

    border-bottom: 1px solid ${color};

    font-family: ${textFont};
    caret-color: ${color};
    color: ${textColor};
    ::placeholder {
      color: ${color};
      font-family: ${fonts.athelas};
      font-style: italic;
      
    }
  `};
`;

class TextAreaInput extends React.PureComponent {
  handleValueChange = event => {
    const { name, form, fields, updateStoreValue } = this.props;
    const { value } = event.target;
    if (fields[[name]].error) {
      updateStoreValue({ name, value: value.slice(-1), form });
    } else {
      updateStoreValue({ name, value, form });
    }
  };

  render() {
    const { name, color, text, fields } = this.props;
    const value = fields[[name]].error ? fields[[name]].error : fields[[name]].value;
    const textColor = fields[[name]].error ? '#FF6347' : color;
    const textFont = fields[[name]].error ? fonts.athelas : fonts.monterrat;

    return (
      <AreaSection>
        <AreaProper
          className="simpleForm"
          name={name}
          value={value}
          placeholder={text || name}
          type="text"
          onChange={this.handleValueChange}
          color={color}
          textColor={textColor}
          textFont={textFont}
        />
      </AreaSection>
    );
  }
}

TextAreaInput.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  updateStoreValue: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  fields: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  fields: state.contactForm.forms[ownProps.form].fields
});

const mapDispatchToProps = dispatch => ({
  updateStoreValue(value) {
    dispatch(updateField(value));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextAreaInput);



// WEBPACK FOOTER //
// ./src/components/ContactForm/Inputs/TextArea/index.jsx